import React from 'react'

import Loader from 'components/ui/loader'

import Info from './info'
import { ResultElement, IResult } from './resultElement'

interface IProps {
  data: IResult[]
  isLoading?: boolean
  showCount?: boolean
  onClick?: (id: string) => void
}

const Results: React.FC<IProps> = (props) => {
  const { data, showCount, isLoading } = props

  const handleClick = (id: string) => {
    if (props.onClick) {
      props.onClick(id)
    }
  }

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {showCount && <Info count={data.length} />}

          {data.map((result: IResult, index) => {
            return <ResultElement key={index} {...result} onClick={handleClick} />
          })}
        </>
      )}
    </div>
  )
}

export default Results
